import { Box, BoxProps, Text } from '@chakra-ui/react';
import React from 'react';
import useTimer from 'utils/hooks/useTimer';

type Props = {
  amount: number;
  txt: string;
  textPosition: 'left' | 'right';
  showAfter?: number;
  variant?: 'normal' | 'small';
} & BoxProps;

const PanelIndicator = ({
  amount,
  txt,
  textPosition,
  showAfter,
  variant = 'normal',
  ...props
}: Props) => {
  const timePassed = useTimer(!!showAfter, 1000);

  return (
    <Box
      visibility={showAfter && timePassed < showAfter ? 'hidden' : 'visible'}
      opacity={showAfter && timePassed < showAfter ? 0 : 1}
      transition="all 0.3s ease-in-out"
      position="absolute"
      top="10px"
      right="-20px"
      width={variant === 'small' ? '140px' : '180px'}
      backgroundColor="white"
      borderRadius="10"
      padding={{ base: '3px 10px', md: '0px 20px' }}
      display="flex"
      gap={3}
      flexDirection={textPosition === 'right' ? 'row' : 'row-reverse'}
      alignItems="center"
      boxShadow="0 0 10px 5px rgba(0, 0, 0, 0.05)"
      {...props}
    >
      <Text
        marginRight={textPosition === 'right' ? '20px' : '0'}
        marginLeft={textPosition === 'left' ? '0px' : '0'}
        color="primaryColor"
        fontSize={variant === 'small' ? 30 : 42}
        fontWeight="bold"
        textAlign="center"
        position="relative"
        top="2px"
      >
        {amount}
      </Text>

      <Text
        color="titleColor"
        fontSize={variant === 'small' ? 14 : 16}
        lineHeight={variant === 'small' ? '14px' : '16px'}
        textAlign="center"
      >
        {txt}
      </Text>
    </Box>
  );
};

export default PanelIndicator;
